import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { Panel } from '@depop/web-ui-kit/Panel';
import clsx from 'clsx';

import styles from './styles.module.css';

type Props = {
  message: React.ReactNode;
  Icon: React.FC<{ className: string }>;
  className?: string;
};

export function InfoBanner({ Icon, message, className }: Props) {
  return (
    <Panel id="infoBanner" className={clsx(styles.panel, className)}>
      <div className={styles.content}>
        <Icon className={styles.icon} />
        <Body variant="sm-regular">{message}</Body>
      </div>
    </Panel>
  );
}
